<template lang="">
    <div>
    <h1>Data Initializing...........</h1>
        
    </div>
</template>
<script>
export default {
    name: 'Refresh',
    data() {
        return {
            from: '',
            to: ''
        }
    },
    beforeRouteEnter (to, from, next) {
        this.from = from
        next()
    },
    beforeCreate() {
        this.$router.push(from)
    }
    
}
</script>
<style lang="">
    
</style>